<template>
  <div class="change-avatar">
    <div class="change-avatar__preview">
      <div class="change-avatar__avatar">
        <img :src="currentAvatar.src" alt="Аватар">
      </div>
      <button class="change-avatar__button-change" type="button" @click="optionsActive = !optionsActive">
        Изменить аватар
      </button>
    </div>
    <ChangeAvatarOptions v-if="optionsActive" @closeModal="optionsActive = !optionsActive"
                         :optionsData="optionsData" :currentAvatar="currentAvatar" >
    </ChangeAvatarOptions>
  </div>
</template>

<script>
import ChangeAvatarOptions from "@/components/changeAvatar/ChangeAvatarOptions";
import axios from 'axios';

export default {
  name      : "СhangeAvatar",
  components: {
    ChangeAvatarOptions
  },
  data() {
    return {
      optionsActive: false,
      optionsData  : {
        avatarsData: [],
        genders    : [],
        hairStyle  : []
      },
      currentAvatar: {
        'src': "/local/templates/adaptive_cmtshop/reviews/src/assets/images/account-default-avatar.png",
      },
      sessid: ''
    }
  },
  methods: {
    initData() {
      let that = this;
      axios.get('/api/forum/v1/avatar/')
          .then(response => {
            if (
                response
                && response.data
                && response.data.result === true
            ) {
              that.optionsData = response.data.avatars;

              if(
                  response.data.userAvatar
                  && response.data.userAvatar.hasOwnProperty('src')
                  && !!response.data.userAvatar.src

              ) {
                that.currentAvatar = response.data.userAvatar;
              }

              that.sessid = response.data.sessid;
            }
          });
    },
    getSessid(){
      return this.sessid;
    },
    setUserAvatar(avatar) {
      console.log(avatar);
      this.currentAvatar = avatar;
    }
  },
  mounted() {
    this.initData();
  }
}
</script>

<style></style>